import React, { useState } from 'react';
import AuctionItem from '../AuctionItem/AuctionItem';
import Spinner from '../Spinner/Spinner';

const AuctionList = ({
  auctions,
  totalResults,
  pageSize,
  pageIndex,
  onPageChange,
  loading,
  auctionType,
}) => {
  const [inputPage, setInputPage] = useState(pageIndex + 1);
  const totalPages = Math.ceil(totalResults / pageSize);

  const handleNextPage = () => {
    if (pageIndex < totalPages - 1) {
      onPageChange(pageIndex + 1);
    }
  };

  const handlePrevPage = () => {
    if (pageIndex > 0) {
      onPageChange(pageIndex - 1);
    }
  };

  const handlePageInput = (e) => {
    const value = parseInt(e.target.value, 10);
    if (value >= 1 && value <= totalPages) {
      setInputPage(value);
    }
  };

  const handleInputBlur = () => {
    const page = Math.max(1, Math.min(inputPage, totalPages)) - 1;
    onPageChange(page);
  };

  return (
    <div className="w-full">
      {loading ? (
        <div className="flex flex-col items-center justify-center py-12">
          <Spinner />
          <p className="text-gray-500 mt-4">Se încarcă licitațiile...</p>
        </div>
      ) : (
        <>
          <div className="flex flex-col gap-6">
            {auctions.map((auction, index) => (
              <React.Fragment key={index}>
                <AuctionItem auction={auction} auctionType={auctionType} />
                {index < auctions.length - 1 && (
                  <hr className="border-t border-dashed border-indigo-200 my-2" />
                )}
              </React.Fragment>
            ))}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 mt-10 p-4 bg-gradient-to-r from-indigo-50 to-white rounded-xl shadow border border-indigo-100 animate-fade-in">
              <button
                onClick={handlePrevPage}
                disabled={pageIndex === 0}
                className="px-5 py-2 rounded-lg font-bold bg-indigo-100 text-indigo-700 hover:bg-indigo-200 transition disabled:opacity-50 disabled:cursor-not-allowed"
              >
                &laquo; Pagina Anterioară
              </button>

              <div className="flex items-center gap-2 text-gray-700 font-semibold">
                Pagina
                <input
                  type="number"
                  value={inputPage}
                  onChange={handlePageInput}
                  onBlur={handleInputBlur}
                  min="1"
                  max={totalPages}
                  className="w-16 px-2 py-1 border border-gray-200 rounded-lg text-center focus:ring-2 focus:ring-indigo-400 outline-none bg-indigo-50 mx-2"
                />
                din {totalPages}
              </div>

              <button
                onClick={handleNextPage}
                disabled={pageIndex === totalPages - 1}
                className="px-5 py-2 rounded-lg font-bold bg-indigo-100 text-indigo-700 hover:bg-indigo-200 transition disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Pagina Următoare &raquo;
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AuctionList;
